import { IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const FEATURE_PAGES = `
...on featurePages_Entry {
  id
  typeHandle
  anchorId
  
  headingAdvanced { html }
  description

  featurePagesContent {
    ... on featurePagesContent_Entry {
      id
      featureCards {
        ... on featureCard_Entry {
          heading
          description

          ${ IMAGE_MOBILE }
          ${ IMAGE_DESKTOP }

          ${ LINK_TITLE }
        }
      }
    }
  }
}
`
